import { ReportTableType } from '../types/ReportTableType';

import { REPORTS_TABLES_TYPES_LABELS } from '../constants/ReportsTablesTypesLabels';

export const convertReportKeyToTitle = (key: ReportTableType): string => {
    let title = '';
    title = REPORTS_TABLES_TYPES_LABELS[key];
    return title;
};
